module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDEiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MSA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHJ4PSIyMCIgZmlsbD0iIzFFOTBGRiIvPgo8cGF0aCBkPSJNMjIuNSAyMS41SDI1TDI2IDE3LjVIMjIuNVYxNS41QzIyLjUgMTQuNDcgMjIuNSAxMy41IDI0LjUgMTMuNUgyNlYxMC4xNEMyNS42NzQgMTAuMDk3IDI0LjQ0MyAxMCAyMy4xNDMgMTBDMjAuNDI4IDEwIDE4LjUgMTEuNjU3IDE4LjUgMTQuN1YxNy41SDE1LjVWMjEuNUgxOC41VjMwSDIyLjVWMjEuNVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/fb-icon-n.svg
// module id = L+yx
// module chunks = 1